import React, { useEffect, useState } from "react";
import useApi from "../utils/useApi";
import "../css/User.css";
import { useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import ic_no_data from "../img/ic_no_data.svg";
import "../css/toggle_switch.css";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import ic_user from "../img/ic_user.png";
import { Autocomplete, TextField } from "@mui/material";

function UserRightsSetting() {
  const DEPARTMENT =
    localStorage.getItem("currentSelectedDepartment") || "MAIN";
  const COMPANY_CODE = localStorage?.getItem("companyCode") || "-";
  let API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  const CURRENT_USER = localStorage?.getItem("currentUserName") || "admin";
  const CURRENT_USER_OBJECT = localStorage.getItem("currentUser")
    ? JSON.parse(localStorage.getItem("currentUser"))
    : "";
  const VATPERCENTAGE = CURRENT_USER_OBJECT[0]?.vatp;
  const USER_ACCESS = CURRENT_USER_OBJECT[0]?.useraccess;

  // console.log("User Access", USER_ACCESS);
  const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";

  const query = new URLSearchParams(useLocation().search);

  let initial_data_for_toggleViewOnOffList = {
    All: true,
    On: false,
    Off: false,
  };

  const [toggleViewOnOffList, setToggleViewOnOffList] = useState(
    initial_data_for_toggleViewOnOffList,
  );
  const user_name = query.get("user_name");
  const [filteredRightsList, setFilteredRightsList] = useState(null);
  const [editedDataGetCategoryList, setEditedDataGetCategoryList] =
    useState(null);

  const [arrayToPassToAPI, setArrayToPassToAPI] = useState(null);
  const [searchTextFilterTable, setSearchTextFilterTable] = useState("");
  const {
    data: datagetCategoryList,
    loading: loadinggetCategoryList,
    error: errorgetCategoryList,
    get: getCategoryList,
  } = useApi();
  const {
    data: dataModuleList,
    loading: loadingModuleList,
    error: errorModuleList,
    get: getModuleList,
  } = useApi();
  const [selectedModuleID, setSelectedModuleID] = useState("");
  const [selectedCategoryID, setSelectedCategoryID] = useState(null);
  const [selectedUserRights, setSelectedUserRights] = useState(null);
  const {
    data: getDataUserRights,
    loading: getLoadingUserRights,
    error: getErrorUserRights,
    get: getUserRights,
  } = useApi();
  const {
    data: datapostUpdateUserRights,
    loading: loadingpostUpdateUserRights,
    error: errorpostUpdateUserRights,
    post: postUpdateUserRights,
  } = useApi();

  useEffect(() => {
    if (dataModuleList) {
      let filteredArray = dataModuleList.filter((itemFil) => {
        return itemFil.MODULEID?.trim()?.toUpperCase() === "SALESDOOD";
      });
      if (filteredArray?.length > 0) {
        setSelectedModuleID("SALESDOOD");
      }
    }
  }, [dataModuleList]);

  useEffect(() => {
    if (datagetCategoryList) {
      if (datagetCategoryList?.length > 0) {
        let firstObject = { cat: "ALL" };
        let newArray = [firstObject, ...datagetCategoryList];

        setSelectedCategoryID(newArray[0]);
        setEditedDataGetCategoryList(newArray);
      }
    }
  }, [datagetCategoryList]);

  useEffect(() => {
    if (datapostUpdateUserRights) {
      if (datapostUpdateUserRights?.result?.trim()?.toUpperCase() === "SAVED") {
        alert("Updated User rights");
      }
    }
  }, [datapostUpdateUserRights]);

  useEffect(() => {
    console.log("searchTextFilterTable ", searchTextFilterTable);

    if (searchTextFilterTable?.length > 0) {
      const searchLower = searchTextFilterTable.toLowerCase();
      const filtered = arrayToPassToAPI?.filter(
        (user) =>
          user.descr.toLowerCase().includes(searchLower) ||
          user.code.toLowerCase().includes(searchLower),
      );
      setFilteredRightsList(filtered);
    } else {
      setFilteredRightsList(arrayToPassToAPI);
    }
  }, [searchTextFilterTable]);

  useEffect(() => {
    setArrayToPassToAPI(getDataUserRights);
    setFilteredRightsList(getDataUserRights);
  }, [getDataUserRights]);

  useEffect(() => {
    getModuleList(
      `https://cubixweberp.com:213/api/CpaysCount/CUBOT/MODULELIST/-/-`,
    );

    console.log(
      "apiurl>>>>>",
      `https://cubixweberp.com:213/api/CpaysCount/${COMPANY_CODE}/DEPTACCESSUSER/${encodeURIComponent(user_name)}/-`,
    );
  }, []);

  // earlier like this since we hidden category because it is null no need of this
  // useEffect(() => {

  //     // select category instead of moduleid category comes under submodule
  //     getCategoryList(`https://cubixweberp.com:213/api/CpaysCount/${COMPANY_CODE}/MENUCATEGORY/-/${selectedModuleID}`)
  // }, [selectedModuleID])

  useEffect(() => {
    // select category instead of moduleid category comes under submodule
    getCategoryList(
      `https://cubixweberp.com:213/api/CpaysCount/${COMPANY_CODE}/MENUCATEGORY/-/-`,
    );
  }, []);

  useEffect(() => {
    if (selectedCategoryID?.cat === "ALL" && arrayToPassToAPI === null) {
      // select category instead of moduleid category comes under submodule
      getUserRights(
        `https://cubixweberp.com:213/api/CpaysCount/${COMPANY_CODE}/USERRIGHTS/${user_name}/-`,
      );
    } else {
      console.log("selectedCategoryID ", selectedCategoryID?.cat);

      if (selectedCategoryID?.cat != "ALL") {
        const filtered = arrayToPassToAPI?.filter(
          (user) => user.category === selectedCategoryID?.cat,
        );

        if (toggleViewOnOffList.On) {
          const filteredOn = filtered?.filter((user) => user.HasAccess === "T");
          setFilteredRightsList(filteredOn);
        } else if (toggleViewOnOffList.Off) {
          const filteredOff = filtered?.filter((user) => user.HasAccess === "F");
          setFilteredRightsList(filteredOff);
        } else {
          setFilteredRightsList(filtered);
        }
      } else {
        if (toggleViewOnOffList.On) {
          const filteredOn = arrayToPassToAPI?.filter(
            (user) => user.HasAccess === "T",
          );
          setFilteredRightsList(filteredOn);
        } else if (toggleViewOnOffList.Off) {
          const filteredOff = arrayToPassToAPI?.filter(
            (user) => user.HasAccess === "F",
          );
          setFilteredRightsList(filteredOff);
        } else {
          setFilteredRightsList(arrayToPassToAPI);
        }
      }
    }
  }, [selectedCategoryID]);

  useEffect(() => {
    if (arrayToPassToAPI) {
      console.log("toggleViewOnOffList ", toggleViewOnOffList);

      if (toggleViewOnOffList.All) {
        if (selectedCategoryID?.cat === "ALL") {
          setFilteredRightsList(arrayToPassToAPI);
        } else {
          const filteredNew = arrayToPassToAPI?.filter(
            (user) => user.category === selectedCategoryID?.cat,
          );
          setFilteredRightsList(filteredNew);
        }
      } else if (toggleViewOnOffList.On) {
        const filtered = arrayToPassToAPI?.filter(
          (user) => user.HasAccess === "T",
        );

        if (selectedCategoryID?.cat === "ALL") {
          setFilteredRightsList(filtered);
        } else {
          const filteredNew = filtered?.filter(
            (user) => user.category === selectedCategoryID?.cat,
          );
          setFilteredRightsList(filteredNew);
        }
      } else if (toggleViewOnOffList.Off) {
        const filtered = arrayToPassToAPI?.filter(
          (user) => user.HasAccess === "F",
        );

        if (selectedCategoryID?.cat === "ALL") {
          setFilteredRightsList(filtered);
        } else {
          const filteredNew = filtered?.filter(
            (user) => user.category === selectedCategoryID?.cat,
          );
          setFilteredRightsList(filteredNew);
        }
      }
    }
  }, [toggleViewOnOffList]);

  const clickedOnCheckMarkSubModule = (codeName) => {
    console.log("codeName ", codeName);

    if (
      selectedUserRights?.findIndex((itemParent) => itemParent === codeName) >= 0
    ) {
      setSelectedUserRights(
        selectedUserRights?.filter((item) => item != codeName),
      );
    } else {
      if (selectedUserRights) {
        setSelectedUserRights([...selectedUserRights, codeName]);
      } else {
        setSelectedUserRights([codeName]);
      }
    }
  };
  const saveUserRights = () => {
    let arraytoPass = [
      {
        CmpCode: COMPANY_CODE,
        mode: "ENTRY",
        user1: user_name,
        user2: "-",
        task_creator_id: "ADMIN",
        useraccess:
          arrayToPassToAPI
            ?.filter((itemFil) => itemFil.HasAccess === "T")
            ?.map((item) => {
              return item.code;
            })
            .join("") + "-",
      },
    ];

    let serialize = JSON.stringify(arraytoPass);

    console.log("arraytoPass>>. ", arraytoPass);

    postUpdateUserRights(
      `https://cubixweberp.com:213/api/CRMUserRights`,
      serialize,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
  };

  function getMatchingObjects(arr1, arr2) {
    const matchingObjects = [];

    // Iterate through each object in the first array
    arr1.forEach((obj1) => {
      // Check if a matching object exists in the second array
      const foundMatch = arr2.some((obj2) => {
        // Define your matching criteria here.
        // For example, if objects are considered a match if their 'id' properties are equal:
        return obj1.code === obj2.code;
        // Or, for a deep comparison of all properties (requires a helper function or library):
        // return deepEquals(obj1, obj2);
      });

      // If a match is found, add the object from the first array to the result
      if (foundMatch) {
        matchingObjects.push(obj1);
      }
    });

    return matchingObjects;
  }

  const handleChangeSwitch = (codeFromClick, valueFromSwitch) => {
    console.log(
      "value from Switch codeFromClick",
      valueFromSwitch,
      codeFromClick,
      getDataUserRights,
    );

    let newUserRights = arrayToPassToAPI?.map((itemURights) => {
      // console.log("itemURights", itemURights)
      if (itemURights.code === codeFromClick) {
        if (valueFromSwitch === "T") {
          return { ...itemURights, HasAccess: "F" };
        } else {
          return { ...itemURights, HasAccess: "T" };
        }
      } else {
        return itemURights;
      }
    });

    console.log("newUserRights", newUserRights);

    setArrayToPassToAPI(newUserRights);

    if (filteredRightsList) {
      let filterArrayToShowInUI = getMatchingObjects(
        newUserRights,
        filteredRightsList,
      );
      console.log("filterArrayToShowInUI ", filterArrayToShowInUI);

      setFilteredRightsList(filterArrayToShowInUI);
    } else {
      setFilteredRightsList(arrayToPassToAPI);
    }
  };

  return (
    <div className="p-3">
      <div className="flex">
        <div className="">
          {editedDataGetCategoryList ? (
            <div className="flex items-center gap-2 mb-2">
              <Autocomplete
                sx={{ width: "300px" }}
                options={editedDataGetCategoryList}
                value={selectedCategoryID}
                getOptionLabel={(option) => (option.cat ? option.cat : "")}
                onChange={(event, newValue) => {
                  console.log("selected category", newValue);
                  setSelectedCategoryID(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select category"
                    variant="outlined"
                  />
                )}
                filterOptions={(options, { inputValue }) =>
                  options.filter((option) =>
                    option.cat.toLowerCase().includes(inputValue.toLowerCase()),
                  )
                }
              />
              {arrayToPassToAPI && arrayToPassToAPI?.length > 0 && (
                <div>
                  <button
                    className="bg-blue-100 text-blue-700 font-semibold rounded p-2 my-4"
                    onClick={() => saveUserRights()}
                  >
                    Update User Rights
                  </button>
                </div>
              )}
            </div>
          ) : (
            <p style={{ marginLeft: "10px" }}>No Categories found</p>
          )}
        </div>
      </div>

      {/* {
                console.log("arrayToPassToAPI UI", arrayToPassToAPI)
            } */}

      {
        // earlier like this (selectedModuleID?.trim() === "" || selectedCategoryID?.cat?.trim() === "" || selectedCategoryID?.cat?.trim() === undefined) ?

        selectedCategoryID?.cat?.trim() === "" ||
        selectedCategoryID?.cat?.trim() === undefined ? (
          <p className="mt-2 text-md text-red-500">
            Please select module and category
          </p>
        ) : (
          <>
            {arrayToPassToAPI?.length === 0 && getLoadingUserRights === false ? (
              <div className="p-4">
                <img style={{ width: "100px" }} src={ic_no_data}></img>{" "}
                <p className="mt-3">No data found</p>
              </div>
            ) : (
              <div>
                <div
                  className="flex justify-between items-center"
                  style={{
                    backgroundColor: "#ffffff",
                    position: "sticky",
                    top: "0px",
                    zIndex: 3,
                  }}
                >
                  <input
                    placeholder="Search rights"
                    className="border border-gray-300 rounded px-3 py-2 "
                    onChange={(e) => setSearchTextFilterTable(e.target.value)}
                  />

                  <div className="flex">
                    <label className="ms-4">Show</label>

                    <button
                      className="ms-4 flex"
                      onClick={() =>
                        setToggleViewOnOffList({
                          ...toggleViewOnOffList,
                          All: true,
                          On: false,
                          Off: false,
                        })
                      }
                    >
                      {toggleViewOnOffList.All ? (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12"
                            cy="12"
                            r="9"
                            stroke="#FFA500"
                            strokeWidth="2"
                            fill="none"
                          />
                          <circle cx="12" cy="12" r="5" fill="#FFA500" />
                        </svg>
                      ) : (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12"
                            cy="12"
                            r="9"
                            stroke="#808080"
                            strokeWidth="2"
                            fill="none"
                          />
                        </svg>
                      )}
                      All
                    </button>

                    <button
                      className="ms-4 flex"
                      onClick={() =>
                        setToggleViewOnOffList({
                          ...toggleViewOnOffList,
                          All: false,
                          On: true,
                          Off: false,
                        })
                      }
                    >
                      {toggleViewOnOffList.On ? (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12"
                            cy="12"
                            r="9"
                            stroke="#FFA500"
                            strokeWidth="2"
                            fill="none"
                          />
                          <circle cx="12" cy="12" r="5" fill="#FFA500" />
                        </svg>
                      ) : (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12"
                            cy="12"
                            r="9"
                            stroke="#808080"
                            strokeWidth="2"
                            fill="none"
                          />
                        </svg>
                      )}
                      On
                    </button>
                    <button
                      className="ms-2 flex"
                      onClick={() =>
                        setToggleViewOnOffList({
                          ...toggleViewOnOffList,
                          All: false,
                          On: false,
                          Off: true,
                        })
                      }
                    >
                      {toggleViewOnOffList.Off ? (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12"
                            cy="12"
                            r="9"
                            stroke="#FFA500"
                            strokeWidth="2"
                            fill="none"
                          />
                          <circle cx="12" cy="12" r="5" fill="#FFA500" />
                        </svg>
                      ) : (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12"
                            cy="12"
                            r="9"
                            stroke="#808080"
                            strokeWidth="2"
                            fill="none"
                          />
                        </svg>
                      )}
                      Off
                    </button>
                  </div>
                </div>

                <div
                  class="overflow-x-auto mt-0"
                  style={{ height: "50vh", overflowY: "scroll" }}
                >
                  <table
                    class="min-w-full divide-y divide-gray-200 border border-gray-300"
                    style={{ "border-collapse": "collapse" }}
                  >
                    <thead>
                      <tr
                        class="bg-gray-100"
                        style={{ position: "sticky", top: "0px", zIndex: 3 }}
                      >
                        <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                          Has Access
                        </th>
                        {/* <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                                                    Code
                                                </th> */}
                        <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                          Description
                        </th>
                        <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                          Category
                        </th>
                        {/*
                                                <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                                                    Module
                                                </th> */}
                      </tr>
                    </thead>
                    <tbody class="bg-white divide-y divide-gray-200">
                      {filteredRightsList?.map((item) => {
                        return (
                          <tr class="hover:bg-gray-50">
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {
                                <FormControlLabel
                                  onChange={(e) =>
                                    handleChangeSwitch(
                                      item.code,
                                      item.HasAccess,
                                    )
                                  }
                                  control={
                                    <Switch checked={item.HasAccess === "T"} />
                                  }
                                  label={item.HasAccess === "T" ? "On" : "Off"} // Dynamic label based on state onChange={handleChange}
                                />
                              }
                            </td>
                            {/* <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.code}</td> */}
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {item.descr}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {item.category}
                            </td>
                            {/*<td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.module}</td> */}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </>
        )
      }
    </div>
  );
}

export default UserRightsSetting;
